import {Link} from "react-router-dom";
import {User} from "../../api/accessControl/User.ts";
import {usePaymentProviderSync} from "./usePaymentProviderSync.ts";
import {LoadingState} from "../bankAccountConnectionFlow/SyncBankDataStates.tsx";

function GoToAppButton(props: { redirectTo: string }) {
    return <div className="flex justify-center w-full mt-16">
        <Link to={props.redirectTo}
              className="inline-flex items-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:opacity-70 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary">
            Naar de app &rarr;
        </Link>
    </div>;
}

function PaymentSyncSuccess(props: { paymentProviderName: string, totalTransactions: number }) {
    return <>
        <div className="flex items-center flex-col my-8">
            <div role="status">
                <div className="flex-shrink-0">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                         strokeWidth="1.5" stroke="currentColor" className="size-24 text-green-400">
                        <path strokeLinecap="round" strokeLinejoin="round"
                              d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                    </svg>
                </div>
            </div>
        </div>
        <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Gegevens succesvol geïmporteerd!
        </p>
        <p className="mt-6 text-lg leading-8 text-gray-600">
            Het is ons gelukt om je saldi en transacties van {props.paymentProviderName} te importeren.
            We hebben {props.totalTransactions} transacties gevonden. Je kunt nu doorgaan naar de app.
        </p>
    </>;
}

function PaymentSyncError(props: { error: string }) {
    return <>
        <div>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 strokeWidth="1.5" stroke="currentColor" className="size-64 text-primary opacity-70 mx-auto">
                <path strokeLinecap="round" strokeLinejoin="round"
                      d="M15.182 16.318A4.486 4.486 0 0 0 12.016 15a4.486 4.486 0 0 0-3.198 1.318M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Z"/>
            </svg>
        </div>
        <div className="p-2 rounded-md text-lg leading-8 text-gray-600">
            {props.error}
        </div>
        <p className="mt-2 text-sm text-gray-500">
            Het ophalen van je gegevens gaat op de achtergrond verder. Je kunt gewoon doorgaan naar de app.
        </p>
    </>;
}

export function PaymentProviderConnectSuccessPage(props: {
    paymentProviderName: string,
    redirectTo: string,
    syncJobsGroupId: string | null,
    currentUser: User,
}) {
    const {progress, totalTransactions, error, isFinished, hasJobStarted} = usePaymentProviderSync(
        props.syncJobsGroupId,
        props.currentUser.getToken(),
    );

    const renderSyncState = () => {
        if (error) return <PaymentSyncError error={error}/>;
        if (isFinished) return <PaymentSyncSuccess paymentProviderName={props.paymentProviderName}
                                                   totalTransactions={totalTransactions}/>;
        return <LoadingState hasJobStarted={hasJobStarted} progress={progress}/>;
    };

    return <div className="mx-auto max-w-2xl text-center">
        <p className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            {props.paymentProviderName} succesvol gekoppeld!
        </p>
        {renderSyncState()}
        <GoToAppButton redirectTo={props.redirectTo}/>
    </div>;
}
